import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScholarshipPaymentStoreActions,
  ScholarshipPaymentStoreSelectors,
  ScholarshipPaymentStoreReducer,
} from './index';
import { ScholarshipPaymentDto } from '@cradua/data';

@Injectable()
export class ScholarshipPaymentFacade {
  constructor(
    private store: Store<
      ScholarshipPaymentStoreReducer.ScholarshipPaymentPartialState
    >
  ) {}

  // scholarshipPaymentRecord$ = this.store.select(ScholarshipPaymentStoreSelectors.getSelected);
  // searchedStudentRecord$ = this.store.select(ScholarshipPaymentStoreSelectors.getSearchStudentRecord);

  scholarshipPaymentRecordError$ = this.store.select(
    ScholarshipPaymentStoreSelectors.getScholarshipPaymentError
  );

  getselected() {
    return this.store.select(ScholarshipPaymentStoreSelectors.getSelected);
  }

  isLoadingScholarshipPayment(id: string) {
    this.store.dispatch(
      ScholarshipPaymentStoreActions.loadScholarshipPayment({ id })
    );
    return this.store.select(
      ScholarshipPaymentStoreSelectors.loadingScholarshipPayment
    );
  }

  loadScholarshipPayment(id: string) {
    console.log('facade ', id);
    this.store.dispatch(
      ScholarshipPaymentStoreActions.loadScholarshipPayment({ id })
    );
  }

  get getScholarshipPaymentData() {
    return this.store.select(
      ScholarshipPaymentStoreSelectors.getAllScholarshipPayment
    );
  }

  searchStudentRecord(query) {
    this.store.dispatch(
      ScholarshipPaymentStoreActions.searchScholarshipPaymentRecord({ query })
    );
  }

  addScholarshipPayment(newScholarshipPayment: ScholarshipPaymentDto) {
    this.store.dispatch(
      ScholarshipPaymentStoreActions.addScholarshipPayment({
        newScholarshipPayment,
      })
    );
  }

  updateScholarshipPayment(updateScholarshipPayment: ScholarshipPaymentDto) {
    this.store.dispatch(
      ScholarshipPaymentStoreActions.updateScholarshipPayment({
        updateScholarshipPayment,
      })
    );
  }

  removeScholarshipPayment(ids: string) {
    this.store.dispatch(
      ScholarshipPaymentStoreActions.removeScholarshipPayment({ ids })
    );
  }
}
